module.exports = __webpack_public_path__ + "img/Groups.4e137057.svg";